var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["category/templates/facets/custom-price-range.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var t_1;
t_1 = (lineno = 0, colno = 38, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["navItem.customPriceRange.isSelected"]));
frame.set("customPriceRangeIsSelected", t_1, true);
if(frame.topLevel) {
context.setVariable("customPriceRangeIsSelected", t_1);
}
if(frame.topLevel) {
context.addExport("customPriceRangeIsSelected", t_1);
}
output += "\n";
var t_2;
t_2 = (lineno = 1, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.currencyFormattingInfo.currencyPrefix"])) || env.getFilter("trim").call(context, (lineno = 1, colno = 80, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.currencyFormattingInfo.currencySuffix"])));
frame.set("currencyPrefix", t_2, true);
if(frame.topLevel) {
context.setVariable("currencyPrefix", t_2);
}
if(frame.topLevel) {
context.addExport("currencyPrefix", t_2);
}
output += " \n";
var t_3;
t_3 = (lineno = 2, colno = 33, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.currencyFormattingInfo.currencySymbol"]));
frame.set("currencyDisplaySymbol", t_3, true);
if(frame.topLevel) {
context.setVariable("currencyDisplaySymbol", t_3);
}
if(frame.topLevel) {
context.addExport("currencyDisplaySymbol", t_3);
}
output += "\n\n<div class=\"dom-custom-price-range c-custom-price ";
if(runtime.contextOrFrameLookup(context, frame, "customPriceRangeIsSelected")) {
output += "is-selected";
;
}
output += "\">\n    <h3 class=\"c-custom-price__header\">\n        ";
output += runtime.suppressValue((lineno = 6, colno = 10, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["category_custom-price-range-header"])) + "" + " ", env.opts.autoescape);
output += "<span class=\"c-custom-price__currency-header\">";
output += runtime.suppressValue((lineno = 6, colno = 102, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["category_custom-price-range-currency",runtime.makeKeywordArgs({"params": [runtime.contextOrFrameLookup(context, frame, "currencyPrefix")]})])), env.opts.autoescape);
output += "</span>\n    </h3>\n\n    <form action=\"#\" method=\"post\" class=\"c-custom-price__form js-price-range-form\" data-qa-custom-price-range-form data-query-string=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"customPriceRange")),"queryString"), env.opts.autoescape);
output += "\">\n        <div class=\"c-custom-price__form-field\">\n            ";
var t_4;
t_4 = (lineno = 11, colno = 30, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["navItem.customPriceRange.min",""]));
frame.set("minVal", t_4, true);
if(frame.topLevel) {
context.setVariable("minVal", t_4);
}
if(frame.topLevel) {
context.addExport("minVal", t_4);
}
output += "\n            ";
var t_5;
t_5 = (lineno = 12, colno = 30, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["navItem.customPriceRange.max",""]));
frame.set("maxVal", t_5, true);
if(frame.topLevel) {
context.setVariable("maxVal", t_5);
}
if(frame.topLevel) {
context.addExport("maxVal", t_5);
}
output += "\n            ";
var t_6;
t_6 = (lineno = 13, colno = 37, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["navItem.customPriceRange.hasBeenEdited",runtime.contextOrFrameLookup(context, frame, "False")]));
frame.set("hasBeenEdited", t_6, true);
if(frame.topLevel) {
context.setVariable("hasBeenEdited", t_6);
}
if(frame.topLevel) {
context.addExport("hasBeenEdited", t_6);
}
output += "\n            ";
var t_7;
t_7 = !runtime.contextOrFrameLookup(context, frame, "hasBeenEdited") || (!runtime.contextOrFrameLookup(context, frame, "minVal") && !runtime.contextOrFrameLookup(context, frame, "maxVal"));
frame.set("disableApplyButton", t_7, true);
if(frame.topLevel) {
context.setVariable("disableApplyButton", t_7);
}
if(frame.topLevel) {
context.addExport("disableApplyButton", t_7);
}
output += "\n            ";
var t_8;
t_8 = runtime.contextOrFrameLookup(context, frame, "disableApplyButton") && (!runtime.contextOrFrameLookup(context, frame, "customPriceRangeIsSelected"));
frame.set("disableClearButton", t_8, true);
if(frame.topLevel) {
context.setVariable("disableClearButton", t_8);
}
if(frame.topLevel) {
context.addExport("disableClearButton", t_8);
}
output += "\n            ";
var t_9;
t_9 = env.getFilter("length").call(context, env.getFilter("string").call(context, (lineno = 16, colno = 45, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["category.maxPriceRange",999999]))));
frame.set("lengthOfMaxPriceRange", t_9, true);
if(frame.topLevel) {
context.setVariable("lengthOfMaxPriceRange", t_9);
}
if(frame.topLevel) {
context.addExport("lengthOfMaxPriceRange", t_9);
}
output += "\n\n            <div class=\"c-custom-price__input-outer\">\n\n                <label class=\"c-form__label c-custom-price__label\" for=\"custom-price-min\">\n                    ";
output += runtime.suppressValue((lineno = 21, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["category_custom-price-range-min-price-label"])), env.opts.autoescape);
output += "\n                </label>\n\n                <div class=\"c-custom-price__currency-symbol-outer\">\n                    <i class=\"c-custom-price__currency-symbol\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "currencyDisplaySymbol"), env.opts.autoescape);
output += "</i>\n                    <input type=\"text\"\n                     maxlength=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "lengthOfMaxPriceRange"), env.opts.autoescape);
output += "\"\n                     value=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "minVal"), env.opts.autoescape);
output += "\"\n                     name=\"minPrice\" data-qa-custom-price-range-min-price\n                     class=\"c-form__text c-custom-price__input js-min-price-range\"\n                     autocomplete=\"off\"\n                     placeholder=\"";
output += runtime.suppressValue((lineno = 32, colno = 36, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["category_custom-price-range-min-placeholder"])), env.opts.autoescape);
output += "\" />\n                </div>\n\n                <span class=\"c-custom-price__separator\">";
output += runtime.suppressValue((lineno = 35, colno = 58, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["category_custom-price-range-separator"])), env.opts.autoescape);
output += "</span>\n\n                <label class=\"c-form__label c-custom-price__label\" for=\"custom-price-max\">\n                    ";
output += runtime.suppressValue((lineno = 38, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["category_custom-price-range-max-price-label"])), env.opts.autoescape);
output += "\n                </label>\n\n                <div class=\"c-custom-price__currency-symbol-outer\">\n                    <i class=\"c-custom-price__currency-symbol\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "currencyDisplaySymbol"), env.opts.autoescape);
output += "</i>\n                    <input type=\"text\"\n                     maxlength=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "lengthOfMaxPriceRange"), env.opts.autoescape);
output += "\"\n                     value=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "maxVal"), env.opts.autoescape);
output += "\"\n                     data-qa-custom-price-range-max-price\n                     name=\"maxPrice\"\n                     class=\"c-form__text c-custom-price__input js-max-price-range\" autocomplete=\"off\"\n                     placeholder=\"";
output += runtime.suppressValue((lineno = 49, colno = 36, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["category_custom-price-range-max-placeholder"])), env.opts.autoescape);
output += "\" />\n                </div>\n            </div>\n\n            <div class=\"c-custom-price__button-outer\">\n                <button class=\"c-custom-price__button c-custom-price__button--apply js-apply-button\" type=\"submit\" ";
if(runtime.contextOrFrameLookup(context, frame, "disableApplyButton")) {
output += "disabled=\"disabled\"";
;
}
output += "\n                 data-qa-custom-price-range-apply-button>";
output += runtime.suppressValue((lineno = 55, colno = 59, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["category_custom-price-range-apply"])), env.opts.autoescape);
output += "</button>\n\n                <button class=\"c-custom-price__button c-custom-price__button--clear js-custom-price__button--clear\" ";
if(runtime.contextOrFrameLookup(context, frame, "disableClearButton")) {
output += "disabled=\"disabled\"";
;
}
output += " data-qa-custom-price-range-x-button>";
output += runtime.suppressValue((lineno = 57, colno = 204, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["category_custom-price-range-clear"])), env.opts.autoescape);
output += "</button>\n            </div>\n        </div>\n    </form>\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["category/templates/facets/custom-price-range.j2"] , dependencies)